import { authenticateRequest } from '@api/authenticateRequest';

import type { components, operations } from '@type/model';
import type { OmitGroupIdInHeader } from '@type/util';

type GetMemberPath =
  operations['KcplaaMemberController_getKcplaaMemberDetail']['parameters']['path'];
type GetMemberHeaders =
  operations['KcplaaMemberController_getKcplaaMemberDetail']['parameters']['header'];

interface GetMemberProps {
  path: GetMemberPath;
  headers?: OmitGroupIdInHeader<GetMemberHeaders>;
}

type GetMemberResponse = components['schemas']['KcplaaCsMemberView$mZFLkyvTelC5g8XnyQrpOw'];

export const getMember = async ({
  path,
  headers,
}: GetMemberProps): Promise<GetMemberResponse | false> => {
  const response = await authenticateRequest<GetMemberResponse>({
    method: 'get',
    url: `/api/v1/kcplaa/members/${path.licenseNo}`,
    headers,
  });

  console.log('getMembers', { response });
  return response;
};

export type { GetMemberResponse };
